import { Accordion, Typography } from '@forgeglobal/design-framework';
import useStyles from './style';
import {
  DefaultWhyNonRMD,
  DefaultWhichNonRMD,
  RealEstateWhichNonRMD,
  DefaultWhyRMD,
  DefaultWhichRMD,
  RealEstateWhichRMD,
} from './InfoDetails';

interface InfoGroupProps {
  isRMD: boolean;
  assetType: string;
}

const assetCertificationLink =
  'https://forgetrust.com/download/ira-asset-valuation-third-party-certification/';

export const InfoGroup = ({ isRMD, assetType }: InfoGroupProps) => {
  const classes = useStyles();

  const summaryWhich = (
    <Typography className={classes.summary}>
      Which documents do we accept?
    </Typography>
  );
  const summaryWhy = (
    <Typography className={classes.summary}>
      Why are we asking for the documents?
    </Typography>
  );

  const LLCInfoRMD = [
    {
      summary: summaryWhich,
      description: <DefaultWhichRMD link={assetCertificationLink} />,
    },
    {
      summary: summaryWhy,
      description: <DefaultWhyRMD />,
    },
  ];

  const assetInfoRMD = [
    {
      summary: summaryWhich,
      description: <DefaultWhichRMD link={assetCertificationLink} />,
    },
    {
      summary: summaryWhy,
      description: <DefaultWhyRMD />,
    },
  ];

  const RMDInfo = {
    PublicLLC: LLCInfoRMD,
    PrivateLLC: LLCInfoRMD,
    Trusts: assetInfoRMD,
    Extraordinary: assetInfoRMD,
    RealEstate: [
      {
        summary: summaryWhich,
        description: <RealEstateWhichRMD />,
      },
      {
        summary: summaryWhy,
        description: <DefaultWhyRMD />,
      },
    ],
  };

  const defaultInfoNonRMD = [
    {
      summary: summaryWhich,
      description: <DefaultWhichNonRMD />,
    },
    {
      summary: summaryWhy,
      description: <DefaultWhyNonRMD />,
    },
  ];

  const NonRMDInfo = {
    PublicLLC: defaultInfoNonRMD,
    PrivateLLC: defaultInfoNonRMD,
    Trusts: defaultInfoNonRMD,
    Extraordinary: defaultInfoNonRMD,
    RealEstate: [
      {
        summary: summaryWhich,
        description: <RealEstateWhichNonRMD />,
      },
      {
        summary: summaryWhy,
        description: <DefaultWhyNonRMD />,
      },
    ],
  };

  const userInfo = isRMD ? RMDInfo : NonRMDInfo;

  const accordion = userInfo[assetType]?.map((item, index) => (
    <Accordion key={index} title={item.summary}>
      {item.description}
    </Accordion>
  ));

  return <div>{accordion}</div>;
};

export default InfoGroup;
